import http from '@/http'
const URL = '/admin/journeys'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const save = (id, payload) => {
  if (id) {
    return http.put(URL + `/${id}`, payload)
  }
  return http.post(URL, payload)
}

export const create = (payload) => http.post(URL, payload)

// --- Compositor de jornadas por IA ---
export const aiStart = () => http.post(`${URL}/ai/start`)
export const aiTurn = (sessionId, message) => http.post(`${URL}/ai/turn`, { session_id: sessionId, message })
export const aiShow = (id) => http.get(`${URL}/ai/${id}`)
export const update = (id, payload) => http.put(URL + `/${id}`, payload)
export const remove = async (id) => http.delete(URL + `/${id}`)
export const changeStatus = (id, payload) => http.put(URL + `/${id}/status`, payload)
export const duplicate = (id) => http.post(URL + `/${id}/duplicate`)
// Inscrição retroativa: quem já atende ao critério do gatilho entra na jornada
export const enrollExistingPreview = (id) => http.get(URL + `/${id}/enroll-existing/preview`)
export const enrollExisting = (id) => http.post(URL + `/${id}/enroll-existing`)
export const exportJourney = (id) => http.get(URL + `/${id}/export`)
export const importJourney = (payload) => http.post(URL + `/import`, payload)

// Analytics
export const getMetrics = (id) => http.get(URL + `/${id}/analytics/metrics`)
export const getFunnel = (id) => http.get(URL + `/${id}/analytics/funnel`)
export const getEntries = (id, params) => http.get(URL + `/${id}/analytics/entries`, { params })
export const getNodeStats = (id) => http.get(URL + `/${id}/analytics/nodes`)
export const getLogs = (id, params) => http.get(URL + `/${id}/analytics/logs`, { params })
export const getEnrollmentTimeline = (journeyId, enrollmentId) => http.get(URL + `/${journeyId}/analytics/enrollment/${enrollmentId}/timeline`)

// Reference data helpers
// Os endpoints abaixo são paginados no backend (WA templates: 20, tags: 50,
// e-mail: 100). Sem `limit` explícito o dropdown do editor recebe só a primeira
// página e o valor já configurado no nó some do select. `sync=0` evita que a
// listagem de templates espere a ida à Positus/Meta só para montar o dropdown.
export const getEmailTemplates = async () => http.get('/admin/settings/email', { params: { limit: 500 } })
export const getWaTemplates = async () => http.get('/admin/settings/wa/templates', { params: { limit: 500, sync: 0 } })
export const getStatuses = async () => http.get('/admin/settings/status-select')
export const getGroups = async () => http.get('/admin/settings/groups')
export const getTags = async () => http.get('/admin/tags', { params: { limit: 500 } })
export const getForms = async (params) => http.get('/admin/forms', { params })
export const getJourneysList = async () => http.get(URL, { params: { limit: 100 } })
export const getFieldTypes = async () => http.get('/admin/field-types/grouped')
export const getRefStatuses = async () => http.get('/admin/settings/refstatus')
export const getConditionFields = async (params = {}) => http.get('/admin/journeys/condition-fields', { params })
export const getFollowUpRules = async () => http.get('/admin/follow-up-rules', { params: { is_active: 1, limit: 100 } })

export default {
  list,
  show,
  save,
  create,
  update,
  remove,
  changeStatus,
  duplicate,
  enrollExistingPreview,
  enrollExisting,
  exportJourney,
  importJourney,
  getMetrics,
  getFunnel,
  getEntries,
  getNodeStats,
  getLogs,
  getEnrollmentTimeline,
  getEmailTemplates,
  getWaTemplates,
  getStatuses,
  getGroups,
  getTags,
  getForms,
  getJourneysList,
  getFieldTypes,
  getRefStatuses,
  getConditionFields,
  getFollowUpRules,
  aiStart,
  aiTurn,
  aiShow
}
